import { useState, useRef, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import api from "@helpers/api";

import { useCommunity } from "@contexts/CommunityContext";

import * as Mui from "@mui/material";

import CustomModal from "@components/CustomModal";

import {Text} from "@fragments";

import "./styles.css";

import { KeyboardArrowRightRounded, SellRounded } from "@mui/icons-material";
import Parser from "@helpers/parser";
import RefundRequestModal from "../RefundRequestModal";

export default function UserModal({ modalRef }) {
  const { t } = useTranslation("member");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState({});

  const { community } = useCommunity();

  const REF_userId = useRef({});
  const REF_callback = useRef();

  const REF_refundModal = useRef();

  if (!modalRef) return null;

  modalRef.current = {
    open(userId, callback = () => {}) {
      if (!userId) return;
      REF_userId.current = userId;
      REF_callback.current = callback;
      loadUser();
      setOpen(true);
    },
  };

  async function loadUser() {
    setLoading(true);

    try {
      const searchStr = "community/member?full=true&id=" + REF_userId.current;

      const { data } = await api.get(searchStr);

      setUser({ ...data });
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  function handleMemberClick(user) {}
  function handleRequestRefund(charge) {
    console.log(charge);
    REF_refundModal.current.open(charge, loadUser);
  }
  function handleRequestCancel(membership) {
    window.openConfirm({
      title: t("userModal.confirmCancel.title"),
      headline: t("userModal.confirmCancel.headline"),
      subtitle: t("userModal.confirmCancel.subtitle"),
      buttons: [
        {
          text: t("userModal.confirmCancel.confirmButton"),
          onClick: handleExecuteCancel,
          variant: "contained",
          className: "",
          color: "error",
        },
        {
          text: t("userModal.confirmCancel.keepButton"),
          variant: "text",
        },
      ],
    });

    async function handleExecuteCancel() {
      console.log("MEM", membership);

      try {
        const { data } = await api.post("subscription/cancel", {
          id: membership.subscription.provider.id,
        });

        loadUser();
      } catch (e) {
        window.setSnackbar(t("userModal.cancelError"));
      }
    }
  }

  function Payments() {
    if (!user?.id) return null;

    function MembershipBlock({ data }) {
      function Charge({ charge }) {
        return (
          <div className="charge-row">
            <div className="title-charge">
              <span>
                <span className="bold">{t("userModal.grossAmount")}</span> R$
                {Parser.price.brl(charge.amount)}
              </span>
            </div>

            {charge.deleted ? (
              <div className="refunded">
                <span>{t("userModal.refunded")}</span>
              </div>
            ) : (
              <div
                className="anchor"
                onClick={() => handleRequestRefund(charge)}
              >
                {t("userModal.refund")}
              </div>
            )}
          </div>
        );
      }
      return (
        <div className="payment-received-row mb-3">
          <div className="community-payments-title mb-1">
            <img src={data.community.banner} className="cp-banner" />
            <h4 className="bold membership-community">{data.community.name}</h4>
            {data.subscription?.status === 'canceled' && (
              <div className="refunded">
                <span>{t("userModal.canceled")}</span>
              </div>
            )}
            {["active", "pending"].includes(data.subscription?.status) &&
              !data.subscription?.canceled && (
                <div
                  className="anchor"
                  onClick={() => handleRequestCancel(data)}
                >
                  {t("userModal.cancelSubscription")}
                </div>
              )}
          </div>

          {data.payments.map((charge, k) => (
            <Charge charge={charge} key={k} />
          ))}
        </div>
      );
    }

    return (
      <div className="mb-2">
        {user?.memberships.map((membership, mi) => (
          <MembershipBlock data={membership} key={mi} />
        ))}
      </div>
    );
  }

  return (
    <>
      <CustomModal
        maxWidth={450}
        bottomButtonCancelText={t("common:actions.finish")}
        loading={loading}
        title={t("userModal.title")}
        open={open}
        handleClose={() => setOpen(false)}
        bodyComponent={
          open ? (
            <div className="px-4 py-2 user-details">
              {!loading && (
                <>
                  <img className="avatar mt-2" src={user?.avatar} />
                  <h4 className="center bold mt-1">{user?.username}</h4>
                  <h5 className="center">{user?.email?.address}</h5>

                  <Text.h3 icon={<SellRounded />} value={t("userModal.paymentsHistory")} />

                  <Payments />
                </>
              )}
            </div>
          ) : null
        }
      />

      <RefundRequestModal modalRef={REF_refundModal} />
    </>
  );
}
